import { getDownloadURL, getStorage, ref } from "@firebase/storage";
import { useEffect, useState } from "react";
import app from "../firebase";

async function getLandingVideoURL() {
  return getDownloadURL(ref(getStorage(app), '/home-landing-video.mp4'));
}

export function useLandingVideoURL(): [ string | undefined, boolean ] {
  const [ url, setUrl ] = useState<string>();
  const [ loading, setLoading ] = useState(true);

  useEffect(() => {
    getLandingVideoURL().then((val) => {
      setUrl(val);
    }).catch((err) => {
      console.error(err);
    }).finally(() => {
      setLoading(false);
    });
  }, []);

  return [ url, loading ];
}
